// 兼容后端的列表包装；未知响应不能静默当作空列表。
export function responseList(payload, field) {
  if (Array.isArray(payload)) return payload;
  if (payload && typeof payload === 'object') {
    if (field && Array.isArray(payload[field])) return payload[field];
    if (Array.isArray(payload.list)) return payload.list;
    if (Array.isArray(payload.results)) return payload.results;
    if (Array.isArray(payload.data)) return payload.data;
    if (payload.data && typeof payload.data === 'object') {
      if (field && Array.isArray(payload.data[field])) return payload.data[field];
      if (Array.isArray(payload.data.list)) return payload.data.list;
      if (Array.isArray(payload.data.results)) return payload.data.results;
    }
  }
  throw new TypeError('接口未返回预期列表，请检查 Network 中的 Response 结构');
}



// WEBPACK FOOTER //
// ./src/api/response_list.js